import React from 'react';

export const RuLocationModal = {
  title: 'Runup Location Name',
  body: (
    <div>
      <p>
        The location (city, state or island) where the tsunami effects were observed.
      </p>
    </div>
  ),
};
